import { formatVolume } from '@benzinga/pro-ui';
import { ColumnDef } from '@benzinga/table';

import { ChamberBadge, PartyBadge, fullStateName } from './memberBadges';
import { MemberHeadshotCell, ReturnChip } from './TableCells';

export const SecurityTraderColumnsDef = [
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => {
      const { display_name, headshot } = data;
      return <MemberHeadshotCell className="hover:text-bzblue-700" headshot={headshot} name={display_name} />;
    },
    field: 'display_name',
    headerName: 'Name',
    height: 100,
    sortEnabled: true,
    width: 100,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => <ChamberBadge chamber={data.chamber} />,
    field: 'chamber',
    headerName: 'Chamber',
    sortEnabled: true,
    width: 120,
  },
  {
    cellClass: 'security-cell capitalize',
    cellRenderer: ({ data }) => fullStateName(data.state),
    field: 'state',
    headerName: 'State',
    sortEnabled: true,
    valueGetter: ({ data }) => fullStateName(data?.state),
    width: 150,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => <PartyBadge party={data.party} />,
    field: 'party',
    headerName: 'Party',
    sortEnabled: true,
    width: 140,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => {
      if (!data.ttm_total_volume) return '';
      return formatVolume(data.ttm_total_volume);
    },
    field: 'ttm_total_volume',
    headerName: 'Total Volume',
    sortEnabled: true,
    valueGetter: ({ data }) => {
      return data?.ttm_total_volume ?? '';
    },
  },
  {
    cellClass: 'security-cell',
    field: 'ttm_total_trades',
    headerName: 'Total Trades',
    sortEnabled: true,
  },
  {
    cellClass: 'security-cell',
    cellRenderer: ({ data }) => <ReturnChip value={data?.ttm_overall_return} />,
    field: 'ttm_overall_return',
    headerName: 'Overall Return',
    sortEnabled: true,
    valueFormatter: ({ value }) => {
      if (!value) return '';

      return `${(value * 100).toFixed(1)}%`;
    },
  },
] as ColumnDef<any>[];
